import { Shirt, CupSoda, Check } from "lucide-react";
import { useLang } from "@/lib/i18n";

const TypeCard = ({ id, icon: Icon, accent, title, forWhat, desc, list }) => (
  <div className={`group relative overflow-hidden rounded-lg border border-white/10 bg-panel p-8 transition-transform duration-300 hover:-translate-y-1`} data-testid={`type-card-${id}`}>
    <div className={`absolute -right-12 -top-12 h-44 w-44 rounded-full blur-3xl opacity-40 ${accent}`} />
    <div className={`relative grid h-14 w-14 place-items-center rounded-md ${accent}`}>
      <Icon className="h-7 w-7 text-white" />
    </div>
    <p className="relative mt-6 text-xs font-extrabold uppercase tracking-[0.2em] text-slate-400">{forWhat}</p>
    <h3 className="relative mt-1 font-display text-3xl">{title}</h3>
    <p className="relative mt-4 text-slate-300">{desc}</p>
    <ul className="relative mt-6 grid grid-cols-2 gap-2 text-sm font-semibold text-slate-200">
      {list.map((l) => (
        <li key={l} className="flex items-center gap-2">
          <Check className="h-4 w-4 shrink-0 text-gold" /> {l}
        </li>
      ))}
    </ul>
  </div>
);

export const Types = () => {
  const { t } = useLang();
  return (
    <section id="types" className="mx-auto max-w-7xl scroll-mt-20 px-5 py-20 lg:px-8" data-testid="types-section">
      <div className="max-w-2xl">
        <h2 className="font-display text-3xl sm:text-4xl">{t("types.title")}</h2>
        <p className="mt-3 text-base text-slate-400 md:text-lg">{t("types.sub")}</p>
      </div>
      <div className="mt-12 grid gap-6 md:grid-cols-2">
        <TypeCard id="dtf" icon={Shirt} accent="bg-ruby" title={t("types.dtf")} forWhat={t("types.dtf_for")} desc={t("types.dtf_desc")} list={t("types.dtf_l")} />
        <TypeCard id="uvdtf" icon={CupSoda} accent="bg-cap" title={t("types.uv")} forWhat={t("types.uv_for")} desc={t("types.uv_desc")} list={t("types.uv_l")} />
      </div>
    </section>
  );
};
